import React, { useState } from 'react';
import { ArrowLeft, CheckCircle2, Mail } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import AuthShell from '../Auth/AuthShell';

const BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await fetch(`${BASE}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Request failed');
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title={sent ? 'Check your inbox' : 'Reset your password'}
      description={sent ? 'A secure sign-in link is on its way.' : 'We’ll email you a secure sign-in link.'}
    >
      {sent ? (
        <div className="auth-success">
          <span><CheckCircle2 size={24} /></span>
          <h3>Link sent</h3>
          <p>If <strong>{email}</strong> has an account, you’ll receive a sign-in link shortly.</p>
          <button className="btn btn-primary auth-submit" onClick={() => navigate('/login')}>Back to sign in</button>
        </div>
      ) : (
        <form className="auth-form" onSubmit={submit}>
          <label>
            <span>Email address</span>
            <div><Mail size={16} /><input type="email" autoComplete="email" placeholder="you@example.com" value={email} onChange={(event) => setEmail(event.target.value)} required autoFocus /></div>
          </label>
          <p className="auth-form-hint">Use the email connected to your Evercrest workspace.</p>
          {error && <div className="auth-error" role="alert">{error}</div>}
          <button className="btn btn-primary auth-submit" type="submit" disabled={loading}>{loading ? <span className="spinner" /> : 'Send sign-in link'}</button>
          <button type="button" className="auth-back" onClick={() => navigate('/login')}><ArrowLeft size={15} />Back to sign in</button>
        </form>
      )}
    </AuthShell>
  );
}
